// import {primaryColor} from '../../cmsMainStyle'

const userMenuStyle = theme => ({

	usernameTextSmUp: {
		paddingTop: theme.spacing(0),
		paddingBottom: theme.spacing(0),
		paddingLeft: theme.spacing(1),
		paddingRight: theme.spacing(0),
	},

	usernameText: {
		paddingTop: theme.spacing(1),
		paddingBottom: theme.spacing(1),
		paddingLeft: theme.spacing(1),
		paddingRight: theme.spacing(1),
	},

	divider: {
		marginTop: theme.spacing(1),
		marginBottom: theme.spacing(1),

		marginLeft: theme.spacing(1),
		marginRight: theme.spacing(1),
	},

})



export default userMenuStyle